export default __webpack_public_path__ + "media/images/brands/grham-green-6598e99cf8ba4750319422feb2329ddf.png";